module.exports = __webpack_public_path__ + "img/album01_03.c92c13e7.jpg";